export const SET_DATE_FIELD_ACTION = '@registrarBoleto/SET_DATE_FIELD_ACTIONS';
export const SET_SIMPLE_REGISTRAR_BOLETO_ACTION = '@registrarBoleto/SET_SIMPLE_REGISTRAR_BOLETO_ACTION';
export const SET_COMMON_ACTION = '@registrarBoleto/SET_COMMON_ACTION';
export const SET_BUSCAR_DADOS_TABELA = '@registrarBoleto/SET_BUSCAR_DADOS_TABELA';
export const LIST_IDS = '@registrarBoleto/LIST_IDS';
export const SET_BUSCAR_IDS_BOLETOS = 'registrarBoleto/SET_BUSCAR_IDS_BOLETOS';
export const REGISTRAR_BOLETO_SELECIONADO = 'registrarBoleto/REGISTRAR_BOLETO_SELECIONADO';
export const INSERT_BOLETO = 'registrarBoleto/INSERT_BOLETO';
export const SET_REQUEST_FIELDS_VALUE = 'registrarBoleto/SET_REQUEST_FIELDS_VALUE';
